import Validation from "@/validation/Validation";

class CompanyValidation extends Validation {
    static getCustomErrorMessages() {
        return {
            custom: {
                // General Details
                CompanyName: {
                    required: 'The Entity Name is required',
                },
                CompanyCode: {
                    required: 'The Entity Code is required',
                    max: 'The Entity Code field may not be greater than 10 characters',
                },
                CompanyGroup_FK: {
                    required: 'The Reporting Group field is required'
                },
                CompanyType_Entity_FK: {
                    required: 'The Classification field is required'
                },
                CompanyType_LloydsStatus_FK: {
                    required: 'The Lloyds Status field is required'
                },
                CompanyExtension: {
                    max: 'The Entity Type field may not be greater than 20 characters',
                },
                // Profile
                VATCode: {
                    max: 'The VAT Code field may not be greater than 25 characters',
                },
                IsBankDetails: {
                    required: 'The Bank Details field is required'
                },
                IsReportChamberOfCommerceCertificate: {
                    required: 'The Report Chamber of Commerce Certificate field is required'
                },
                IsPIInsurance: {
                    required: 'The PI Insurance\n field is required'
                },
                IsRUI: {
                    required: 'The RUI field is required'
                },
                IsVisura: {
                    required: 'Visura field is required'
                },
                FinancialStatements: {
                    max: 'The Financial Statements field may not be greater than 255 characters',
                },
                SyndicateAcronym: {
                    max: 'The Syndicate Acronym field may not be greater than 25 characters',
                },
                SyndicateNumber: {
                    max: 'The Syndicate Number field may not be greater than 25 characters',
                },
                // Address
                AddressType: {
                    required: 'The Address Type field is required'
                },
                AddressLine1: {
                    required: 'The Address Line 1 field is required'
                },
                City: {
                    required: 'The City field is required'
                },
                PostalCode: {
                    required: 'The Postal Code field is required'
                },
                Country: {
                    required: 'The Country field is required'
                },
                // TOBA
                TOBAType_FK: {
                    required: 'The Type field is required'
                },
            }
        }
    }
}

export default CompanyValidation;
